import CircularProgress from '@mui/material/CircularProgress';
import { useErrorContext } from '@qpr/client-library';
import React, { useEffect, useState } from 'react';
import ElementList from '../components/ElementList';
import { Data } from '../elementsList-state';
import createElementsListViewModel, { ElementsListViewModelType } from './elementsList-view-model';

interface ElementListViewProps {
  title?: string;
  itemTitleAttribute?: string;
  query?: string;
}

const ElementListView = ({
  title = 'No title',
  query,
  itemTitleAttribute = 'name'
}: ElementListViewProps) => {
  const [data, setData] = useState<Data[]>();
  const { setError } = useErrorContext();

  const viewModel: ElementsListViewModelType = createElementsListViewModel({
    query: query || '',
    itemTitleAttribute
  });

  useEffect(() => {
    const initData = async () => {
      const gotData = await viewModel.getData();
      setData(gotData.data);
      if (gotData.error?.message) setError(gotData.error);
    };
    initData();
  }, []);

  return data ? (
    <ElementList title={title} data={data} />
  ) : (
    <div data-testid="loadingIndicator" style={{ width: '40px', margin: 'auto' }}>
      <CircularProgress />
    </div>
  );
};

export default ElementListView;
